import NoImage from '/no-image.png';

import useProductStore from '@/stores/productStore';

const ReviewImage = () => {
  const image = useProductStore(d => d.image);

  return (
    <div className='flex h-16 w-16 flex-row justify-center'>
      <img src={image || NoImage} className='rounded-default w-full' />
    </div>
  );
};

export default ReviewImage;
